module.exports = "/_next/static/images/water-distribution-37d4113ff5a9cdbb78cc1d94a913cbd6.webp";